import ToastsContainer from "../../Componant/BonusUI/Toasts";

const Toasts = () => {
  return (
    <div className="page-body">
      <ToastsContainer />
    </div>
  );
};

export default Toasts;
